import { ModalService } from "../modules/shared/modal/modal.service";
import { PopupBlockedModalComponent } from "../modules/shared/popup-blocked-modal/popup-blocked-modal.component";

export const getUrlParamValue = (queryString: string, paramName: string): string | undefined => {
  if (!queryString) {
    return undefined;
  }
  return new URLSearchParams(queryString.replace(/^[^?]*\?/, '')).get(paramName) ?? undefined;
};

export const setQueryStringParam = (queryString: string, paramName: string, paramValue: string): string => {
  const searchParams = new URLSearchParams(queryString);
  searchParams.set(paramName, paramValue);
  return searchParams.toString();
};

export const getUserCombiPackageIdFromRoute = (params: { [key: string]: string }, queryParams: { [key: string]: string }): string | undefined => {
  return queryParams["usercombipackageid"] ||
      queryParams["userCombiPackageID"] ||
      queryParams["userCombiPackageId"] ||
      params["usercombipackageid"] ||
      undefined;
};

// navigation state flag set by LoginComponent when it sends the user on to a returnUrl
export const NAVIGATED_FROM_LOGIN = "navigatedFromLogin";

/**
 * Only allows app-internal paths ("/something"), so a crafted login link can't send the user to another site.
 */
export const getSafeReturnUrl = (returnUrl: string | null | undefined): string | undefined => {
  if (!returnUrl || !returnUrl.startsWith("/") || returnUrl.startsWith("//") || returnUrl.startsWith("/\\")) {
    return undefined;
  }
  return returnUrl;
};

export const openPotentiallyBlockedWindow = async (url: string, modalService: ModalService<any>, target: "_blank" | "_top" = "_blank") => {
  const opened = window.open(url);

  if (!opened || opened.closed || typeof opened.closed === "undefined") {
    // popup blocked (first time on Safari/Opera/Chrome), so have the user open it by clicking a link, otherwise the 'opener' is null so the opened window can't be closed programmatically
    const modal: ModalService<PopupBlockedModalComponent> = modalService.create(PopupBlockedModalComponent);
    modal.component.href = url;
    modal.component.target = target;
    await modal.open();
  }
};
